module.exports = __webpack_public_path__ + "static/media/todoList.523debb1.png";